import { Disclosure } from '@headlessui/react'
import { ChevronDownIcon } from '@ordr-as/icons'

interface Props {
    label: string
    object: Map<string, string>
}

const ObjectAccordion = (props: Props) => {
    const { label, object } = props

    return (
        <Disclosure>
            {({ open }) => (
                <div className="my-2">
                    <Disclosure.Button className="font-semibold flex justify-between w-[100%] items-center">
                        <span className={`${open ? 'text-brand-primary' : ''} transition-colors`}>{label}</span>
                        <ChevronDownIcon
                            className={`${open ? 'transform rotate-180' : ''} transition-transform text-brand-primary `}
                        />
                    </Disclosure.Button>
                    <Disclosure.Panel>
                        <div className="border-l-2 border-brand-primary ml-2 mt-2 mb-4 pl-2">
                            {Object.entries(object).length > 0 ? (
                                Object.entries(object).map(([key, value], idx) => (
                                    <div key={key}>
                                        <div key={idx} className="my-2 flex justify-between">
                                            <div className="font-semibold">{key}</div>
                                            <div>{value}</div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="ml-3 italic">No unintegrated fields</div>
                            )}
                        </div>
                    </Disclosure.Panel>
                </div>
            )}
        </Disclosure>
    )
}

export default ObjectAccordion
